import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import Collapsible from '../../../../components/collapsible/Collapsible';
import Clickable from '../../../../components/clickable/Clickable';
import PhotoCarousel from '../../../../components/photoCarousel';
import Modal from '../../../../components/modal';
import { renderInfoForType } from '../../../../utils/helpers';

import styles from '../../../workorders/Detail/workOrderDetail.module.scss';

class OprationReview extends Component {
    state = {
      modal: false
    };

    openPhotoModal = (idx) => {
      this.setState({ modal: true, initialSlide: idx });
    }

    render() {
      const { step, info, translation, handleWildlifeSpeciesField, schema } = this.props;
      const { modal, initialSlide } = this.state;

      return (
        <Collapsible title={'Operation Review'}
          styleClasses={styles.collapsibleHeader}
          offset={1}
          openOnMount
        >
          <div className={styles.stepInfo}>
            <div className={styles.infoHalf}>
              <FormattedMessage
                id={schema?.default_fields?.default_logged_by?.title || 'workorder.detail.info.completed_by'}
                defaultMessage={schema?.default_fields?.default_logged_by?.title || 'Completed by'}
              />
              <p>{info.completed_by.fullname}</p>
            </div>
            <div className={styles.infoHalf}>
              <FormattedMessage
                id={schema?.default_fields?.default_reported_date?.title || 'workorder.detail.info.completed_on'}
                defaultMessage={schema?.default_fields?.default_reported_date?.title || 'Completed on'}
              />
              <p>{moment(info.completed_on).format('MM/DD/YYYY hh:mm A')}</p>
            </div>
            {(step === 'operation'|| step==='airfield-opeartion') && (
            <div className={styles.infoFull}>
                <FormattedMessage
                  id={schema?.default_fields?.default_description?.title || 'workorder.detail.info.description'}
                  defaultMessage={schema?.default_fields?.default_description?.title || 'Description of work done'}
                />
              <p>{info.work_description}</p>
            </div>
            )}
            {(info?.operations_answer?.answer_schema?.fields ||[]).map(f => (
              <div key={f.id} className={f.widget && f.widget.type === 'textfield' ? styles.infoFull : styles.infoHalf}>
                <span>{translation && translation?.[f.title] ? translation?.[f.title]: f.title}</span>
                {((f.type === 'wildlife_species') || (f.type === 'dataSource' && f.dataSourceID === 'ds10'))
                && Object.keys(info[f.id] || {})?.length > 0 ? (
                  <>
                  {handleWildlifeSpeciesField(f, info)}
                  </>
                  ): (
                <p>{renderInfoForType(f, info.response[f.id], info)}</p>
                  )}
              </div>
            ))}
            {info.attachments.length > 0 && (
            <div className={styles.infoFull}>
                <FormattedMessage
                  id={schema?.default_fields?.default_photos?.title || 'workorder.detail.request.photos'}
                  defaultMessage={schema?.default_fields?.default_photos?.title || 'Photos'}
                />
              <div className={styles.images}>
                {info.attachments.map((e, idx) => (
                  <Clickable
                    key={e.id}
                    onClick={() => this.openPhotoModal(idx)}
                  >
                    <img src={e.image || e.url} alt={e.id} />
                  </Clickable>
                ))}
              </div>
            </div>
            )}
          </div>
          {info.attachments.length > 0 && (
          <Modal
            showIn={modal}
            onClose={() => this.setState({ modal: false })}
            contentStyles={{
              overflow: 'visible',
              background: '#E6EAEE',
              padding: '20px 40px'
            }}
          >
            <div>
              {info.attachments.length > 1
                ? <PhotoCarousel photos={info.attachments} initialSlide={initialSlide} />
                :(
                  <div>
                    <img src={info.attachments[0].image || info.attachments[0].url} className={styles.workimg} alt="" />
                  </div>
                )
              }
            </div>
          </Modal>
          )}
        </Collapsible>
      );
    }
  }

  OprationReview.propTypes = {
    info: PropTypes.shape({}).isRequired,
    step: PropTypes.string.isRequired
  };
  export default OprationReview;
